// Hallazgos de inspección: un registro por cada ítem en alerta o falla de una
// inspección vigente. (Antes "incidentes"; se renombró para no confundirse con
// la app/bitácora de Incidentes del parque.)
import { esTardio } from 'lib/tardio';
import { etiquetasDe, checklistDe, instalacionDe } from 'lib/auditoriaInstalaciones';

const SEVERIDAD = { falla: 0, alerta: 1 };

const cacheEtiquetas = {};
const cacheOrden = {};
const etiquetas = (inst) => {
  if (!cacheEtiquetas[inst]) cacheEtiquetas[inst] = etiquetasDe(inst);
  return cacheEtiquetas[inst];
};
const orden = (inst) => {
  if (!cacheOrden[inst]) {
    cacheOrden[inst] = Object.fromEntries((checklistDe(inst)?.items || []).map((i, n) => [i.key, n]));
  }
  return cacheOrden[inst];
};

// Filas de cables_inspecciones -> un hallazgo por cada ítem en alerta o falla.
// Se recorre `resultados` (la fuente de verdad del estado), no `detalles`: una
// alerta o falla sin nota (histórico importado, o una fila sin detalle) debe
// aparecer igual, con nota vacía. Las inspecciones anuladas no cuentan. El
// nombre del ítem sale del checklist de la instalación de cada fila.
export function flattenHallazgos(rows) {
  const out = [];
  for (const r of rows || []) {
    if (!r || r.anulada) continue;
    const inst = instalacionDe(r);
    const label = etiquetas(inst);
    const res = r.resultados || {};
    const det = r.detalles || {};
    for (const key of Object.keys(res)) {
      const estado = res[key];
      if (estado !== 'alerta' && estado !== 'falla') continue;
      out.push({
        inspeccion_id: r.id,
        instalacion: inst,
        fecha: r.fecha,
        fecha_hora: r.fecha_hora,
        created_at: r.created_at,
        tardio: esTardio(r),
        guia: r.guia_nombre || '',
        itemKey: key,
        item: label[key] || key,
        orden: orden(inst)[key] ?? 99,
        estado,
        nota: det[key]?.nota || '',
        fotos: Array.isArray(det[key]?.fotos) ? det[key].fotos : [],
      });
    }
  }
  out.sort((a, b) =>
    (b.fecha || '').localeCompare(a.fecha || '') ||
    (b.fecha_hora || '').localeCompare(a.fecha_hora || '') ||
    (SEVERIDAD[a.estado] - SEVERIDAD[b.estado]) ||
    (a.orden - b.orden) ||
    String(a.inspeccion_id).localeCompare(String(b.inspeccion_id))
  );
  return out;
}

export function filtrarHallazgos(hallazgos, { estado = '', item = '' } = {}) {
  return (hallazgos || []).filter((i) =>
    (!estado || i.estado === estado) && (!item || i.itemKey === item));
}
